import React, { useState, useEffect } from 'react';
import { Container, Modal, Button } from 'react-bootstrap';
import Tilt from 'react-parallax-tilt';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS CSS
import './Badges.css';

const badgeData = [
  {
    id: 1,
    title: "Holopin x Hacktoberfest: 1 Badge Club",
    img: "https://assets.holopin.io/eyJidWNrZXQiOiJob2xvcGluLWFzc2V0cyIsImtleSI6ImFzc2V0cy9jbWcyejhoMW4wMDAwanUwNGJxOHUzdWw2IiwiZWRpdHMiOnsicm90YXRlIjpudWxsfX0=",
    description: "Awarded to the fine folks who have earned at least one Hacktoberfest badge since 2022. Kudos!",
  },
  {
    id: 2,
    title: "Hacktoberfest 2025: Level 3",
    img: "https://assets.holopin.io/hf2025levels/lvl3-human.webp",
    description: "Contributors who submitted three accepted PR/MRs for Hacktoberfest 2025 are rewarded with this badge.",
  },
  {
    id: 3,
    title: "Hacktoberfest 2024: Registered",
    img: "https://assets.holopin.io/hf2024levels/level0-sloth-code-0-0-0-0.webp",
    description: "Participants who registered for Hacktoberfest 2024 are rewarded with this badge.",
  },
  {
    id: 4,
    title: "Hacktoberfest 2022: Level 4",
    img: "https://assets.holopin.io/eyJidWNrZXQiOiJob2xvcGluLWFzc2V0cyIsImtleSI6ImFzc2V0cy9jbDhkOHVrb3MwMDk0MDlqbnVuaGRhcDd3IiwiZWRpdHMiOnsicm90YXRlIjpudWxsfX0=",
    description: "Contributors that submitted four accepted PR/MRs for Hacktoberfest 2022 are rewarded with this badge.",
  },
  {
    id: 5,
    title: "Hacktoberfest 2022: Registered",
    img: "https://assets.holopin.io/eyJidWNrZXQiOiJob2xvcGluLWFzc2V0cyIsImtleSI6ImFzc2V0cy9jbDhlcTN6OWMwMzU3MDlsM2Z4OTluOHg2IiwiZWRpdHMiOnsicm90YXRlIjpudWxsfX0=",
    description: "Participants that registered for Hacktoberfest 2022 are rewarded with this badge.",
  },
  {
    id: 6,
    title: "Appwrite Hacktoberfest 2023 Participation Badge",
    img: "https://assets.holopin.io/eyJidWNrZXQiOiJob2xvcGluLWFzc2V0cyIsImtleSI6ImFzc2V0cy9jbG15cWdyMGUwMjI1enV6amdxZmYwbmhsIiwiZWRpdHMiOnsicm90YXRlIjpudWxsfX0=",
    description: "You've earned this badge for being a participant in the Hacktoberfest 2023 10th year anniversary. Let's celebrate open source together and join the Appwrite community!",
  },
  {
    id: 7,
    title: "Appwrite Hacktoberfest 2022",
    img: "https://assets.holopin.io/eyJidWNrZXQiOiJob2xvcGluLWFzc2V0cyIsImtleSI6ImFzc2V0cy9jbGFqeHF4eTUwNDMzMDhqc3k3bXp1NmlwIiwiZWRpdHMiOnsicm90YXRlIjpudWxsfX0=",
    description: "This badge is a token of appreciation from the Appwrite team for taking part in Hacktoberfest 2022. Thank you for being awesome in helping grow the open source community!",
  },
  {
    id: 8,
    title: "DigitalOcean Smiley",
    img: "https://assets.holopin.io/eyJidWNrZXQiOiJob2xvcGluLWFzc2V0cyIsImtleSI6ImFzc2V0cy9jbG16YzVpdWYxMDA0ODBma3V6dTBxYnpxOCIsImVkaXRzIjp7InJvdGF0ZSI6bnVsbH19",
    description: "A surprise from DigitalOcean for Hacktoberfest participants. Thank you for contributing to open-source!",
  },
  {
    id: 9,
    title: "Surfer Moby Dock",
    img: "https://assets.holopin.io/eyJidWNrZXQiOiJob2xvcGluLWFzc2V0cyIsImtleSI6ImFzc2V0cy9jbDlmczZqdWgxNjI1ODA5bWkyNXAyNjRtbiIsImVkaXRzIjp7InJvdGF0ZSI6bnVsbH19",
    description: "A special surprise from Docker for Hacktoberfest participants! Moby Dock, a cartoon whale that hauls shipping containers on its back, is the mascot of Docker.",
  },
  {
    id: 10,
    title: "Early Bird Pegasaurus",
    img: "https://assets.holopin.io/eyJidWNrZXQiOiJob2xvcGluLWFzc2V0cyIsImtleSI6ImFzc2V0cy9jbDd0ZDhncDUwMTMyMDlrMHd1OHFlNHg5IiwiZWRpdHMiOnsicm90YXRlIjpudWxsfX0=",
    description: "This badge is awarded to those who joined early or tried out a badge demo. Fun fact: it’s the very first badge ever released on Holopin, proudly flying since 2022 ;)",
  },
  {
    id: 11,
    title: "ILLA Hacktoberfest 2023 Participation Badge",
    img: "https://assets.holopin.io/eyJidWNrZXQiOiJob2xvcGluLWFzc2V0cyIsImtleSI6ImFzc2V0cy9jbG16MW5neWQwMjM3bTN6am50c2V6Yng2IiwiZWRpdHMiOnsicm90YXRlIjpudWxsfX0=",
    description: "The ILLA Badge for Hacktoberfest 2023 Contributors!",
  },
  {
    id: 12,
    title: "Pegasaurus Egg",
    img: "https://assets.holopin.io/eyJidWNrZXQiOiJob2xvcGluLWFzc2V0cyIsImtleSI6ImFzc2V0cy9jbGJ2ZGRhZWE4MTk3MDhsaTdqZ2Y2cHRyIiwiZWRpdHMiOnsicm90YXRlIjpudWxsfX0=",
    description: "This is a pegasaurus badge that grows over time, from a mere egg into an amazing software developer.",
  },
  {
    id: 13,
    title: "Hacktoberfest 2023: Registered",
    img: "https://assets.holopin.io/hf2023levels/level0-gold-0-0-0.webp",
    description: "Participants who registered for Hacktoberfest 2023 are rewarded with this badge.",
  }
];

const Badges = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedBadge, setSelectedBadge] = useState(null);

  // Initialize AOS once when component mounts
  useEffect(() => {
    AOS.init({
      duration: 1200, // Animation duration (in ms)
      once: true,     // Animation runs only once
      easing: 'ease-in-out',
    });
  }, []);

  const handleBadgeClick = (badge) => {
    setSelectedBadge(badge);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedBadge(null);
  };

  return (
    <Container
      className="my-5"
      data-aos="fade-up"          // 👈 Animation type
      data-aos-duration="1500"    // Optional: override duration
      data-aos-once="true"        // Run only once
    >
      <p className="text-center mybadge-heading">My Badges</p>
      
      <div className="badge-grid">
        {badgeData.map((badge) => (
          <Tilt
            key={badge.id}
            glareEnable={true}
            glareMaxOpacity={0.2}
            glareColor="#fff"
            glarePosition="all"
            tiltMaxAngleX={15}
            tiltMaxAngleY={15}
            scale={1.05}
            className="badge-tilt"
          >
            <div
              className="badge-card"
              onClick={() => handleBadgeClick(badge)}
            >
              <img
                src={badge.img}
                alt={badge.title}
                className="badge-img"
              />
            </div>
          </Tilt>
        ))}
      </div>

      {/* Modal */}
      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedBadge?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img
            src={selectedBadge?.img}
            alt={selectedBadge?.title}
            width="100%"
            className="mb-3"
          />
          <p>{selectedBadge?.description}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default Badges;
